import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import {
  Navbar,
  Hero,
  About,
  Features,
  ResultsGallery,
  Pricing,
  Bonuses,
  Contact,
  Footer
} from './components';
import BlockedPaymentsBack from './pages/BlockedPayments';
import CallingScripts from './pages/CallingScripts';
import CreditControl from './pages/CreditControl';
import Course from './pages/Course';
import CourseContent from './pages/Course/CourseContent';
import VideoPlayer from './pages/Course/VideoPlayer';
import Login from './pages/Auth/Login';
import ChangePassword from './pages/Auth/ChangePassword';
import ThankYou from './pages/CallingScripts/ThankYou';

// Home Page Component
function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      {/* <Navbar /> */}
      
      {/* Hero Section */}
      <Hero />
      
      {/* Features/Benefits Section */}
      <Features />
      
      {/* About Section */}
      <About />
      
      {/* Results Gallery Section */}
      <ResultsGallery />
      
      {/* Bonuses Section */}
      <Bonuses />
      
      {/* Pricing Section */}
      <Pricing />
      
      {/* Contact Section */}
      <Contact />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
                    <Route path="/" element={<CallingScripts />} />
          <Route path="/calling-scripts-2" element={<CallingScripts />} />
          <Route path="/thank-you-apc" element={<ThankYou />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blocked-payments-back" element={<BlockedPaymentsBack />} />
          <Route path="/credit-control" element={<CreditControl />} />
          <Route path="/course" element={
            <ProtectedRoute>
              <Course />
            </ProtectedRoute>
          } />
          <Route path="/course-content" element={<CourseContent />} />
          <Route path="/apc-videos" element={
            <ProtectedRoute>
              <VideoPlayer />
            </ProtectedRoute>
          } />
          <Route path="/change-password" element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
